import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TokenCommonService } from '../token-common.service';
import * as _ from 'lodash';
import 'rxjs/add/operator/map';
import { IBanner } from '../../../model/interface/IBanner';
import { Banner } from '../../../model/class/Banner';

@Injectable()
export class BannerService extends TokenCommonService {

  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

  getActivos () {
    return this.http.get(`${ environment.API_URL }banners/activos`)
      .map(res => {
        return res.json().data;
      });
  }

  getActivosPorTipo(tipo: string, params?: any) {

    const requestParams = new URLSearchParams();
    const options = new RequestOptions({params: requestParams});

    if (typeof params !== 'undefined') {

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });
    }

    return this.http.get(`${ environment.API_URL }banners/${tipo}/activos`, options)
      .map(res => {
        return res.json();
      });
  }

  getDesactivosPorTipo (tipo: string, params?: any) {
    return this.tokenGet(`${ environment.API_URL }banners/${tipo}/desactivos`, params);
  }

  edit(id, data: FormData) {
    return this.tokenPut(`${ environment.API_URL }banners/${id}`, data);
  }

  eliminar(id: number) {
    return this.tokenDelete(`${ environment.API_URL }banners/${id}`);
  }

  crear(data: FormData) {
    return this.tokenPost(`${ environment.API_URL }banners`, data);
  }


}



// WEBPACK FOOTER //
// /app/src/app/services/banner/banner.service.ts